export const tutorialVideos = {
  'LIGHT-X-V5': { //ZIP
     reception: [
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/48b0284b8460318eaf3fac52499eb0a9/manifest/video.m3u8', type: 'video', preloadResource: true },
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/1f9766020e427de97a2e6ff60d03247f/manifest/video.m3u8', type: 'video', preloadResource: true },
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/042f50f341b213e38eb8736c20083242/manifest/video.m3u8', type: 'video', preloadResource: true },
    ],
    retour: [
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/590a1e5b442db548542a6c24384e6e87/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/ad2f590349f2c4bffce163594af7ecef/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/19ceb317ec2c8c190a3503c90927a0ea/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/9b2b1e4222d1acb2c6441f2723c0f333/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/996658c0616d27d4abdb94b0975ce813/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/797969b5ae7d001f7c7b60164bad9b1f/manifest/video.m3u8', type: 'video', preloadResource: true },
    ],
  },
   'LIGHT-X-V2-V3-V4': { // roulé
    reception: [
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/0c5441e1a4402e70f744a27fe781730e/manifest/video.m3u8', type: 'video', preloadResource: true },
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/e8cf43d6272537326ee52b4f26c76d0d/manifest/video.m3u8', type: 'video', preloadResource: true },
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/c9484801148b4ba5dff67eb22d2a6cd5/manifest/video.m3u8', type: 'video', preloadResource: true },
    ],
    retour: [
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/a3e1642a2eeb8a59cd0baa75e19a0b0e/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/2e0c8fc3ca271a9b32720d06d6500e5d/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/762e7fc80c8334cab17b22f1da40b1c6/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/b2a92ab45f18f152e8ee169f64ef23c5/manifest/video.m3u8', type: 'video', preloadResource: true },
    ],
  },
  'BOX': {
    reception: [
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/08c279514555ea05891ae42297a05fe1/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/bdd3539fc344438f4748465586bf3cf4/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/79329ffb825b99770f27cc8fcc1b8b2a/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/5408971955a6ee5d66a233963894dde9/manifest/video.m3u8', type: 'video', preloadResource: true},
    ],
    retour: [
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/f66a0582a9d35aaae4b236a986e196de/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/42b539ff7c7321c1df86f3b8db41518e/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/22c2ccc19ad8b8844fe1133b19c4c1dd/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/2b312be102597b18ce16060254137cd6/manifest/video.m3u8', type: 'video', preloadResource: true },
    ],
  },
   'SLEEVE-V1': { //languette
    reception: [
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/ea46bfbc5e430948d39c5175c4a1be45/manifest/video.m3u8', type: 'video', preloadResource: true },
        { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/1f7ea8345a1e1700b539ce222ff1a804/manifest/video.m3u8', type: 'video', preloadResource: true },
    ],
    retour: [
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/a9a561c5953a50d12507bc6c2937cf5b/manifest/video.m3u8', type: 'video', preloadResource: true },
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/2d53cf6ed7fbf6e68002d11b9f5eb38a/manifest/video.m3u8', type: 'video', preloadResource: true },
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/56d27cad6d4cbb7d783d69fe0a087185/manifest/video.m3u8', type: 'video', preloadResource: true },
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/0103a9999401834236291d3ba81934e3/manifest/video.m3u8', type: 'video', preloadResource: true },
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/3e2d306e03f4bf5116c5b4c9a1515f5c/manifest/video.m3u8', type: 'video', preloadResource: true },
    ],
  },
   'SLEEVE-V2': { //scelle
    reception: [
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/23ae08ab1abe1e2764ca49e9044659c3/manifest/video.m3u8', type: 'video', preloadResource: true },
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/422f01ba0422c253d93692ae82aab932/manifest/video.m3u8', type: 'video', preloadResource: true },
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/46fb4c96ab61092b18618271fea94d4e/manifest/video.m3u8', type: 'video', preloadResource: true },
    ],
    retour: [
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/f57e42677615c3f9e6a28b020a6254af/manifest/video.m3u8', type: 'video', preloadResource: true },
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/8aa6d869d64f69ebed5af8e7fc9e56b4/manifest/video.m3u8', type: 'video', preloadResource: true },
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/0a9d3e7bd27ce06cb2d8c6c5f444423b/manifest/video.m3u8', type: 'video', preloadResource: true },
      { url: 'https://customer-w3g4fv6ckfw8v1zh.cloudflarestream.com/778449d4bfdadaa01a2c12bfaefc12e5/manifest/video.m3u8', type: 'video', preloadResource: true },
      
    ],
  },
};

/**
 * Normalise la version en supprimant le 'v' et les zéros de tête
 * @param {string} version - Version brute (v1, 1, 01, v01, etc.)
 * @returns {string} Version normalisée (1, 2, 5, etc.)
 */
function normalizeVersion(version) {
  if (!version) return '';
  
  // Convertir en string et en minuscules
  let normalized = String(version).toLowerCase().trim();
  
  // Supprimer le 'v' au début s'il existe
  if (normalized.startsWith('v')) {
    normalized = normalized.substring(1);
  }
  
  // Supprimer les zéros de tête sauf si c'est '0'
  normalized = normalized.replace(/^0+(?=\d)/, '');
  
  return normalized;
}

/**
 * Récupère les vidéos tutorielles selon le type, version et action
 * @param {string} type - Type d'emballage (LIGHT-X, BOX, SLEEVE)
 * @param {string} version - Version (v1, v2, v5, 1, 01, "2,3,4", etc.)
 * @param {string} action - Action (reception ou retour)
 * @returns {Array} Liste des vidéos ou tableau vide si non trouvé
 */
export function getTutorialVideos(type, version, action) {
  const normalizedType = type?.toUpperCase();
  const normalizedAction = action?.toLowerCase();

  if (!normalizedType || !normalizedAction) {
    return [];
  }

  // Normaliser LIGHT vers LIGHT-X
  let finalType = normalizedType === 'LIGHT' ? 'LIGHT-X' : normalizedType;

  // Cas BOX : pas de version spécifique
  if (finalType === 'BOX') {
    return tutorialVideos['BOX']?.[normalizedAction] || [];
  }

  // Si version contient des virgules (ex: "2,3,4"), prendre la première
  let versionToUse = version;
  if (version && version.includes(',')) {
    versionToUse = version.split(',')[0].trim();
  }

  // Normaliser la version (v1 → 1, v05 → 5, 01 → 1, etc.)
  const normalizedVersion = normalizeVersion(versionToUse);

  // Construire la clé : TYPE-V{version}
  let key = `${finalType}-V${normalizedVersion}`;

  // Cas spécial LIGHT-X : versions 2, 3, 4 partagent les mêmes vidéos
  if (finalType === 'LIGHT-X' && ['2', '3', '4'].includes(normalizedVersion)) {
    key = 'LIGHT-X-V2-V3-V4';
  }

  return tutorialVideos[key]?.[normalizedAction] || [];
}
